<footer class="w-full relative" [class]="{'hidden': hideElement()}" #footerContainer>

    @if(hyperlinkMode) {

    @if(showLogo()) {

    <div class="flex justify-center pointer-events-auto min-h-12">
        <app-logo />
    </div>

    }

    } @else {
    
    <!-- FOOTER MOBILE WRAPPER -->
    <div class="md:hidden flex z-10 gap-x-2 relative">
        
        <!-- BENEFITS & VENUE LAYOUT BUTTONS -->
        <div
            class="absolute bottom-[calc(100%+(var(--spacing)*4.5))] left-0 flex gap-x-2 pointer-events-auto transition-all"
            [class]="view() === AppViews.Topview ? 'translate-y-0' : '-translate-y-[55px]'"
        >

            <app-benefits-button />

            @if(venueLayout.venueConfigs.enabled()){
                <app-venue-layout-button />
            }

        </div>

        <!-- SEARCH & MENU BUTTONS -->
        <div 
            class="flex z-10 gap-x-2 w-full min-h-[34px]"
            [class]="view() === AppViews.Topview ? 'pointer-events-auto' : 'pointer-events-none'"
        >
            <app-search/>
    
            <app-menu-buttons class="grow overflow-x-auto overflow-y-hidden no-scrollbar"/>
        </div>

    </div>

    <!-- FOOTER DESKTOP WRAPPER -->
    <div class="hidden md:flex justify-between items-center min-h-12">

        <!-- LEFT SPACER (minimap & previews render in the shared wrapper below) -->
        <div class="w-1/3"></div>

        <!-- LOGO -->
        <div class="w-1/3 flex justify-center pointer-events-auto">

            @if(showLogo()) {
                <app-logo />
            }

        </div>

        <!-- ACTION BUTTONS  -->
        <div class="w-1/3">

            <app-link-action-buttons />

        </div>

    </div>

    <!-- MINIMAP & RELATED PREVIEWS -->
    <!-- Single instance for all breakpoints: recreating these closes the DVM minimap singleton and loses preview state -->
    <div class="absolute left-0 bottom-0 z-10">

        <div class="my-4 hidden md:block">
            <app-disclaimer />
        </div>

        <div
            [class]="view() === AppViews.Pano ? 'pointer-events-auto' : 'pointer-events-none'"
            class="flex gap-x-2 w-screen md:w-auto"
        >

            <app-minimap/>

            <div class="overflow-x-auto whitespace-nowrap no-scrollbar md:overflow-visible">
                <app-related-previews/>
            </div>

        </div>

    </div>

    }

</footer>
